import styled from 'styled-components';
import Content from 'gatsby-theme-core/src/components/content';
import Button from 'gatsby-theme-core/src/components/button/index';

export default styled(Content)`
  h1, h2, h3, h4, strong {
    font-family: ${(props) => props.theme.standoutFontFamily};
    margin: 0 0 15px 0;
  }
  h2 {
    font-size: 1.5rem;
  }
  p,
  ul,
  address {
    line-height: 160%;
  }
  h3 {
    line-height: 160%;
  }
  address {
    font-style: normal;
  }
  a:not(${Button}) {
    color: ${(props) => props.theme.primaryColor};
    text-decoration: none;
    opacity: .8;
    &:hover {
      opacity: 1;
    }
  }
  > * {
    &:last-child {
      margin-bottom: 0;
    }
  }
  img {
    max-width: 100%;
    height: auto;
  }
  blockquote {
    font-family: ${(props) => props.theme.standoutFontFamily};
    border-left: 4px solid ${(props) => props.theme.primaryColor};
    padding: 15px;
    margin: 0 0 15px 0;
    font-size: 1.2rem;
    p {
      margin: 0;
      line-height: 160%;
    }
  }
`;
